module.exports = __webpack_public_path__ + "img/xiaohui4.afe5b951.jpg";